<div class="table scrollbar" [ngStyle]="applyStyle()" id="style-1">
  <table style="width: 100%;">

    <tr *ngFor="let item of arrayItems" class="table-row table-row-even" [ngClass]="{'other-row':item.type === 'outros' }">

      <div *ngIf="item.item !== ''">
        <td style="width: 20px;">
          <input type="checkbox" (change)="checkedItem(item)" [checked]="item.selected">
        </td>

        <td (click)="seeItemSelected(item)" [ngClass]="(itemSelected && item === itemSelected) ? 'item-selected' : ''">
          {{ item.item }}
        </td>
      </div>

      <div *ngIf="item.item === '' && item.selected">
        <td style="width: 20px;">
          <input type="checkbox" (change)="checkedItem(item)" [checked]="true" disabled>
        </td>

        <td>
          <input
            type="text"
            class="others"
            [value]=""
            (keydown)="onTabClick($event)"
            (input)="fillText($event , item)"
            (keyup.enter)="onEnter(item)"
          >
        </td>
      </div>

    </tr>

  </table>
</div>
